import {isAndroid} from '../../utils/index';
import {requestBdApi} from '@baidu/map-fe-utils';

export default {
    namespaced: true,

    state: {
        // 是否登陆
        isLogin: false,
        // 微详情的笔记通过iframe引入了携程的页面。ios的bdapi会检测最后一个https的请求，不是百度域名会禁止登录。采用临时的百度域iframe来避免这个问题
        showTempIframe: false
    },

    getters: {
        isLogin: state => state.isLogin,
        showTempIframe: state => state.showTempIframe
    },

    mutations: {
        setIsLogin(state, isLogin) {
            state.isLogin = isLogin;
        },
        setShowTempIframe(state, params) {
            state.showTempIframe = params;
        }
    },

    actions: {
        goLogin({commit}, loginCallbackName = '') {
            commit('setShowTempIframe', true);
            setTimeout(() => {
                // 临时处理方案，后面需要给端提需求。
                if (!isAndroid()) {
                    const iframeTemp = document.querySelector('#tempIframe');
                    iframeTemp.setAttribute('src', 'https://www.baidu.com/');
                }
            }, 0);
            setTimeout(() => {
                // 如果没有传入登录回调名字，则使用默认的回调函数。
                if (!loginCallbackName) {
                    window.loginCallback = data => {
                        if (+data) {
                            commit('setIsLogin', true);
                            commit('setShowTempIframe', false);
                        }
                    };
                }

                requestBdApi('bdapi://login', {
                    login_page: 'normal',
                    callback: loginCallbackName || 'loginCallback'
                });
            }, 100);
        }
    }
};